"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactChartjs = require("react-chartjs-2");
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../constants");
var _hooks = require("../../helpers/hooks");
var Chart = function Chart(_ref) {
  var data = _ref.data,
    heading = _ref.heading,
    centerTextTop = _ref.centerTextTop,
    centerTextBottom = _ref.centerTextBottom,
    vertical = _ref.vertical;
  var foundBgColors = data.datasets.find(function (x) {
    return x.backgroundColor;
  });
  var width = (0, _hooks.useWindowWidth)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('d8-c-chart', vertical && 'vertical')
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-md margin-bottom-md d8-u-color-contrast-high d8-u-ls-sm"
  }, heading), /*#__PURE__*/_react["default"].createElement("div", {
    className: "chart--container flex flex-column flex-row@sm items-center flex-gap-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative d8-u-component-padding container--chart"
  }, /*#__PURE__*/_react["default"].createElement(_reactChartjs.Doughnut, {
    data: data,
    options: {
      cutoutPercentage: 70,
      legend: {
        display: false
      },
      title: {
        display: false
      },
      hoverBackgroundColor: '#fff',
      hoverBorderColor: '#fff',
      tooltips: {
        enabled: width > _constants.BREAKPOINTS.MD,
        backgroundColor: '#ffffff',
        bodyFontColor: 'hsl(220, 8%, 55%)',
        bodyFontFamily: 'sofia-pro, sans-serif',
        borderWidth: 1,
        borderColor: 'hsl(0, 0%, 96%)',
        xPadding: 20,
        yPadding: 20,
        displayColors: false
      }
    },
    height: 300 // no idea why...
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "summary d8-u-color-contrast-high"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold text-xxl"
  }, centerTextTop), /*#__PURE__*/_react["default"].createElement("p", null, centerTextBottom))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "container--legend",
    style: {
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", null, data.labels.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: JSON.stringify(item),
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "dot margin-right-sm flex-shrink-0",
      style: {
        backgroundColor: foundBgColors.backgroundColor[i]
      }
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "d8-u-color-contrast-high text-sm"
    }, item));
  })))));
};
Chart.propTypes = {
  data: _propTypes["default"].object.isRequired,
  heading: _propTypes["default"].string,
  centerTextTop: _propTypes["default"].string,
  centerTextBottom: _propTypes["default"].string,
  vertical: _propTypes["default"].bool
};
var _default = exports["default"] = Chart;